import {View} from 'react-native';
import React from 'react';
import styleSheet from './styles';
import {useTheme} from 'contexts/ThemeContext';
import CalendarView from '../calendarView/index.web';

export interface DropDownCalendarForWebProps {
  onDayPress(date: Date): void;
  startDate?: Date;
  endDate?: Date;
  isSecondCalendar?: boolean;
  isOpen: boolean;
  calendarContainerStyle?: object;
}

const DropDownCalendarForWeb = (props: DropDownCalendarForWebProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  return (
    <>
      {props.isOpen && (
        <View style={props.calendarContainerStyle}>
          <CalendarView
            selected={props.isSecondCalendar ? props.endDate : props.startDate}
            onDayPress={props.onDayPress}
            selectStart={!props.isSecondCalendar}
            selectEnd={!!props.isSecondCalendar}
            startDate={props.isSecondCalendar ? props.endDate : props.startDate}
            endDate={props.isSecondCalendar ? undefined : props.endDate}
            minDate={props.isSecondCalendar ? props.endDate : undefined}
            withoutMarkDay
            calendarContainer={styles.calendarContainer}
          />
        </View>
      )}
    </>
  );
};

export default DropDownCalendarForWeb;
